
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/MFD-AUM-Growth/[lang]",
      function () {
        return require("private-next-pages/MFD-AUM-Growth/[lang].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/MFD-AUM-Growth/[lang]"])
      });
    }
  